module.exports = __webpack_public_path__ + "static/media/41_tn.37328d74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/41_tn.jpg
// module id = 254
// module chunks = 0